import { __assign } from "tslib";
import React from 'react';
import { LazyComponentErrorBoundary } from './LazyComponentErrorBoundary';
/**
 * Helper function to wrap a lazy component with an error boundary.
 * NOTE: If your component gets mounted/unmounted, you might need to memoize the result of this function.
 * @param LazyComponent Lazy component
 * @param componentName Name of component
 * @param lazyFeatureOptions Options for LazyComponentErrorBoundary
 * @returns Lazy component wrapped with error boundary
 */
export var withLazyErrorBoundary = function (LazyComponent, componentName, lazyFeatureOptions) {
    if (lazyFeatureOptions === void 0) { lazyFeatureOptions = {}; }
    var WrappedLazyComponent = function (props) {
        return (React.createElement(LazyComponentErrorBoundary, { lazyFeatureProps: lazyFeatureOptions, componentName: componentName, onError: props.onError },
            React.createElement(LazyComponent, __assign({}, props))));
    };
    WrappedLazyComponent.displayName = componentName;
    return WrappedLazyComponent;
};
//# sourceMappingURL=withLazyErrorBoundary.js.map